import { Entity } from '../../domain/entity'
import { EntityBuilder } from '../../domain/entity/builder'
import { randomIdentifierGenerator } from '../../utils/common/random-identifier-generator'
import { ISubscription, Subscription } from '../identity/adapters/adapter'

// length of random id string; for all profiles (incl. anon);
// for sync w / `other2` on mParticle (TODO)
const idLength = 32
export interface IProfile {
    adLight: boolean
    ageOfMajority: boolean
    created?: Date
    doNotContact?: boolean
    email?: string
    emailConfirmed?: boolean
    familyName?: string
    gender?: string
    givenName?: string
    id: string
    lastSignIn?: Date
    mpId?: string
    name?: string
    postalCode?: string
    province?: string
    subscriptions?: ISubscription[]
    conversions?: string[]
    /**
     * Timestamp for global/local store comparison.
     */
    updated: number
    uuid?: string
}

export class Profile extends Entity implements IProfile {
    public adLight: boolean
    public ageOfMajority: boolean
    public created: Date
    public doNotContact: boolean
    public emailConfirmed: boolean
    public familyName?: string
    public gender: string
    public givenName?: string
    public id = randomIdentifierGenerator(idLength)
    public lastSignIn: Date
    public mpId: string
    public name: string
    public province: string
    public postalCode: string
    public subscriptions: ISubscription[]
    public conversions: string[]
    public updated = Date.now()
    public uuid: string

    constructor(public email?: string) {
        super()
    }

    public fromJson(data: object) {
        super.fromJson(data)

        // parse date
        if ((data as this).created) {
            this.created = new Date(Date.parse((data as any).created))
        }

        if ((data as this).lastSignIn) {
            this.lastSignIn = new Date(Date.parse((data as any).lastSignIn))
        }

        // parse subscriptions
        if ((data as this).subscriptions) {
            this.subscriptions = EntityBuilder.buildMany<Subscription>(Subscription, (data as any).subscriptions)
        }
    }
}
